/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Doc: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="doc" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M453.3333333333333 340H906.6666666666666V453.3333333333334H453.3333333333333V340zM453.3333333333333 566.6666666666667H906.6666666666666V680H453.3333333333333V566.6666666666667zM340 113.3333333333335H226.6666666666667V1133.3333333333333C226.6666666666667 1164.5 237.7733333333333 1191.1333333333334 259.9866666666667 1213.4033333333334A109.14 109.14 0 0 0 340 1246.6666666666667H793.3333333333333L1133.3333333333333 906.6666666666669V226.6666666666668C1133.3333333333333 195.5 1122.2266666666665 168.8666666666668 1100.07 146.5966666666668A109.14 109.14 0 0 0 1020 113.3333333333335H340zM736.6666666666666 850V1133.3333333333333H340V226.6666666666668H1020V850H736.6666666666666z" : "M362.6666666666667 272H725.3333333333334V362.6666666666667H362.6666666666667V272zM362.6666666666667 453.3333333333333H725.3333333333334V544H362.6666666666667V453.3333333333333zM272 90.6666666666666H181.3333333333334V906.6666666666666C181.3333333333334 931.6 190.2186666666667 952.9066666666666 207.9893333333334 970.7226666666666A87.312 87.312 0 0 0 272 997.3333333333334H634.6666666666667L906.6666666666669 725.3333333333333V181.3333333333333C906.6666666666669 156.3999999999999 897.7813333333334 135.0933333333333 880.056 117.2773333333332A87.312 87.312 0 0 0 816 90.6666666666666H272zM589.3333333333334 680V906.6666666666666H272V181.3333333333333H816V680H589.3333333333334z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Doc.displayName = `Blueprint5.Icon.Doc`;
export default Doc;
